import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PREDEFINED_TASKS_DELETE } from "./apiRoutes";

export interface DeletePredefinedTaskResponse {
  message: string;
  success: boolean;
}

const deletePredefinedTask = async (id: string) => {
  const response = await axiosAuth.delete<DeletePredefinedTaskResponse>(
    `${PREDEFINED_TASKS_DELETE}${id}/`
  );
  return response.data;
};

export const useDeletePredefinedTaskMutation = (
  options?: UseMutationOptions<
    DeletePredefinedTaskResponse,
    Error,
    string
  >
) => {
  return useMutation({
    mutationFn: deletePredefinedTask,
    ...options,
  });
};
